"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var contexts_1 = require("../../contexts");
var utils_1 = require("../../utils");
var FocusedContainer_1 = require("../FocusedContainer");
var Keyboard_1 = require("../Keyboard");
var StyledLayer_1 = require("./StyledLayer");
var HiddenAnchor = styled_components_1.default.a(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  position: absolute;\n"], ["\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  position: absolute;\n"])));
var LayerContainer = /** @class */ (function (_super) {
    tslib_1.__extends(LayerContainer, _super);
    function LayerContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.anchorRef = React.createRef();
        _this.containerRef = React.createRef();
        _this.layerRef = React.createRef();
        _this.makeLayerVisible = function () {
            var node = _this.layerRef.current || _this.containerRef.current;
            if (node && node.scrollIntoView) {
                node.scrollIntoView();
            }
        };
        return _this;
    }
    LayerContainer.prototype.componentDidMount = function () {
        var position = this.props.position;
        if (position !== 'hidden') {
            this.makeLayerVisible();
            // once layer is open we set the focus in the hidden
            // anchor so that you can start tabbing inside the layer
            if (this.anchorRef.current) {
                var focusElement = this.anchorRef.current;
                focusElement.focus();
            }
        }
    };
    LayerContainer.prototype.componentDidUpdate = function (prevProps) {
        var position = this.props.position;
        if (prevProps.position !== position && position !== 'hidden') {
            this.makeLayerVisible();
        }
    };
    LayerContainer.prototype.render = function () {
        var _a = this.props, children = _a.children, id = _a.id, modal = _a.modal, onClickOutside = _a.onClickOutside, onEsc = _a.onEsc, plain = _a.plain, position = _a.position, responsive = _a.responsive, propsTheme = _a.theme, rest = tslib_1.__rest(_a, ["children", "id", "modal", "onClickOutside", "onEsc", "plain", "position", "responsive", "theme"]);
        var theme = this.context || propsTheme;
        var content = (React.createElement(StyledLayer_1.StyledContainer, tslib_1.__assign({ id: id }, rest, { position: position, plain: plain, responsive: responsive, ref: this.containerRef }),
            React.createElement(HiddenAnchor, { ref: this.anchorRef, tabIndex: "-1", "aria-hidden": "true" }),
            children));
        if (modal) {
            content = (React.createElement(StyledLayer_1.StyledLayer, { id: id, plain: plain, position: position, responsive: responsive, tabIndex: "-1", ref: this.layerRef },
                React.createElement(StyledLayer_1.StyledOverlay, { plain: plain, onMouseDown: onClickOutside, responsive: responsive }),
                content));
        }
        if (onEsc) {
            content = React.createElement(Keyboard_1.Keyboard, { onEsc: onEsc }, content);
        }
        if (theme.layer.background) {
            var dark = utils_1.backgroundIsDark(theme.layer.background, theme);
            if (dark !== theme.dark) {
                content = React.createElement(contexts_1.ThemeContext.Provider, { value: tslib_1.__assign(tslib_1.__assign({}, theme), { dark: dark }) }, content);
            }
        }
        if (modal) {
            content = (React.createElement(FocusedContainer_1.FocusedContainer, { hidden: position === 'hidden', restrictScroll: true }, content));
        }
        return content;
    };
    LayerContainer.contextType = contexts_1.ThemeContext;
    LayerContainer.defaultProps = {
        full: false,
        margin: 'none',
        modal: true,
        position: 'center'
    };
    return LayerContainer;
}(React.Component));
exports.LayerContainer = LayerContainer;
var templateObject_1;
//# sourceMappingURL=LayerContainer.js.map